import defaultTheme from './defaultTheme';

const themes = {
  default: defaultTheme,
};

export default themes;
